import React from 'react';
import { Icon } from '@chakra-ui/react';

export const TwitterLogo = () => {
	return (
		<Icon
			width="12px"
			height="11px"
			viewBox="0 0 8 7"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.56713 0.548969C7.27473 0.75522 6.95098 0.91297 6.60836 1.01614C6.42446 0.804696 6.18006 0.654828 5.90822 0.586809C5.63637 0.518789 5.35019 0.535899 5.08839 0.635824C4.82658 0.73575 4.60178 0.91367 4.44439 1.14552C4.287 1.37737 4.20461 1.65197 4.20837 1.93217V2.23751C3.67177 2.25142 3.14006 2.13241 2.66059 1.89108C2.18113 1.64975 1.76878 1.29359 1.46029 0.854311C1.46029 0.854311 0.238926 3.60239 2.987 4.82375C2.35816 5.25061 1.60904 5.46464 0.849609 5.43444C3.59769 6.96115 6.95644 5.43444 6.95644 1.92301C6.95616 1.83796 6.94799 1.75311 6.93202 1.66957C7.24365 1.36224 7.46356 0.974222 7.56713 0.548969Z"
				fill="white"
			/>
		</Icon>
	);
};

export default TwitterLogo;
